import { render } from "./Details.vue?vue&type=template&id=98fd37ac"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"

import "./Details.vue?vue&type=style&index=0&id=98fd37ac&lang=css"

import exportComponent from "C:\\Users\\Librom\\Projects\\librodex-v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__